import { Button, Tooltip } from 'antd';
import { DeleteOutlined, EditOutlined } from '@mui/icons-material';

export default function templatesAccommodationsColumns(
  editDrawer?: ((record: any) => void) | any,
  deleteTemplate?: ((record: any) => void) | any,
  status?: string[]
) {
  const templatesAccommodationsColumns = [
    {
      id: 'RequestId',
      header: 'REQUEST ID',
      accessorKey: 'RequestId',
      enableColumnFilter: false,
      size: 120,
    },
    {
      id: 'Requestor',
      header: 'RESQUESTOR',
      accessorKey: 'Requestor',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 120,
    },
    {
      id: 'RequestDate',
      header: 'REQUEST DATE',
      accessorKey: 'RequestDate',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 140,
    },
    {
      id: 'OD',
      header: 'OD',
      accessorKey: 'OD',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 120,
    },
    {
      id: 'Offices',
      header: 'OFFICE(S)',
      accessorKey: 'Offices',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 120,
    },
    {
      id: 'StartDate',
      header: 'START DATE',
      accessorKey: 'StartDate',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 120,
    },
    {
      id: 'EndDate',
      header: 'END DATE',
      accessorKey: 'EndDate',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 120,
    },
    {
      id: 'CurrentPattern',
      header: 'CURRENT PATTERN',
      accessorKey: 'CurrentPattern',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 140,
    },
    {
      id: 'NewPattern',
      header: 'NEW PATTERN',
      accessorKey: 'NewPattern',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 140,
    },
    {
      id: 'MondayPattern',
      header: 'MONDAY PATTERN',
      accessorKey: 'MondayPattern',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 140,
    },
    {
      id: 'TuesdayPattern',
      header: 'TUESDAY PATTERN',
      accessorKey: 'TuesdayPattern',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 140,
    },
    {
      id: 'WednesdayPattern',
      header: 'WEDNESDAY PATTERN',
      accessorKey: 'WednesdayPattern',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 160,
    },
    {
      id: 'ThursdayPattern',
      header: 'THURSDAY PATTERN',
      accessorKey: 'ThursdayPattern',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 150,
    },
    {
      id: 'FridayPattern',
      header: 'FRIDAY PATTERN',
      accessorKey: 'FridayPattern',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 140,
    },
    {
      id: 'SaturdayPattern',
      header: 'SATURDAY PATTERN',
      accessorKey: 'SaturdayPattern',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 150,
    },
    {
      id: 'SundayPattern',
      header: 'SUNDAY PATTERN',
      accessorKey: 'SundayPattern',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 140,
    },
    {
      id: 'ChangeResults',
      header: 'CHANGE RESULT',
      accessorKey: 'ChangeResult',
      enableColumnFilter: true,
      filterFn: 'contains',
      size: 130,
    },
  ];

  const actionColumn = {
    accessorKey: 'actions',
    header: 'ACTIONS',
    size: 150,
    enableColumnFilter: false,
    enableSorting: false,
    Cell: ({ cell }: { cell: any }) => {
      return (
        <>
          <div className='d-flex w-100' style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {cell?.row?.original.Status == 'PENDING' && (
              <Tooltip placement='top' title='Edit'>
                <Button
                  style={{
                    backgroundColor: '#003366',
                    border: 'none',
                    borderRadius: '5px',
                    width: '24px',
                    height: '25px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  icon={<EditOutlined sx={{ color: 'white', fontSize: 20, marginLeft: '10px', marginRight: '10px' }} />}
                  onClick={() => editDrawer(cell?.row?.original)}
                />
              </Tooltip>
            )}
            {cell?.row?.original.Status !== 'COMPLETED' && (
              <Tooltip placement='top' title='Delete'>
                <Button
                  style={{
                    backgroundColor: '#d14d4d',
                    border: 'none',
                    borderRadius: '5px',
                    width: '24px',
                    height: '25px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  icon={
                    <DeleteOutlined sx={{ color: 'white', fontSize: 20, marginLeft: '10px', marginRight: '10px' }} />
                  }
                  onClick={() => deleteTemplate(cell?.row?.original.RequestId)}
                />
              </Tooltip>
            )}
          </div>
        </>
      );
    },
  };

  let showActions = false;

  if (Array.isArray(status)) {
    if (typeof status[0] === 'string') {
      showActions = status.includes('PENDING');
    } else {
      showActions = status.some((row: any) => Array.isArray(row.Status) && row.Status.includes('PENDING'));
    }
  }

  const columns = showActions ? [...templatesAccommodationsColumns, actionColumn] : templatesAccommodationsColumns;

  return columns;
}
